<script setup lang="ts">
import { bgColors } from '@/services/application/constantes';
import type { StrictTailwindRoundedClass } from '@/services/application';

const sizes = {
  dense: 'h-6 text-xs',
  small: 'h-8 text-sm',
  medium: 'h-10 text-base',
  large: 'h-12 text-lg',
};

type BLabelProps = {
  bgColor?: keyof typeof bgColors;
  size?: keyof typeof sizes;
  rounded?: StrictTailwindRoundedClass;
};

const props = withDefaults(defineProps<BLabelProps>(), {
  bgColor: 'base',
  size: 'small',
  rounded: 'rounded-lg',
});
</script>

<template>
  <span
    class="px-2 inline-flex self-start max-w-full items-center gap-2 text-nowrap line-clamp-1"
    :class="[bgColors[props.bgColor], sizes[props.size], props.rounded]"
  >
    <slot />
  </span>
</template>
